import TechnologyPage from './TechnologyPage';

export default TechnologyPage;
